var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoWebsite = function SvgIcoWebsite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6,2.5C6.2,2.2,2.5,5.6,2.5,10c0,4.1,3.3,7.4,7.3,7.5c4.3,0.1,7.7-3.3,7.7-7.5C17.5,6.1,14.6,2.9,10.6,2.5z M15.9,9.3 h-2.5c-0.1-1.7-0.5-3.4-1.4-4.9C14.1,5.1,15.7,7,15.9,9.3z M10,4C10,4,10,4,10,4C10,4,10,4,10,4c1.2,1.6,1.8,3.4,1.9,5.3H8.1 C8.2,7.4,8.8,5.6,10,4z M8,4.4C7.1,5.9,6.7,7.6,6.6,9.3H4.1C4.3,7,5.9,5.1,8,4.4z M4.1,10.8h2.6c0.1,1.7,0.7,3.5,1.7,5 C6,15.1,4.4,13.1,4.1,10.8z M8.1,10.8h3.8c-0.2,1.7-0.8,3.4-1.9,4.9C8.9,14.2,8.3,12.5,8.1,10.8z M11.7,15.7c0.9-1.5,1.5-3.3,1.6-5 h2.6C15.6,13.1,14,15.1,11.7,15.7z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoWebsite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-website.20217257.svg";
export { ForwardRef as ReactComponent };